<template>
  <div class="copy-pop" v-if="bShow">
    <div class="dialog-wrapper">
      <div class="head">
        <span class="title">{{title}}<span class="sub-title">{{subtitle}}</span></span>
        <img class="close" @click="hide" src="./close.png" alt="close" width="20" height="20">
      </div>
      <div class="content">
        <p class="row">
          <span class="left">开课日期：</span>
          <span class="right">
              <el-date-picker
                v-model="startDateValue"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                size="medium"
              >
              </el-date-picker>
          </span>
        </p>
        <p class="row">
          <span class="left">开始时间：</span>
          <span class="right">
              <el-time-picker
                v-model="timeValue"
                :format="'HH:mm'"
                placeholder="输入时间">
              </el-time-picker>
          </span>
        </p>
        <p class="row">
          <span class="left">结束时间：</span>
          <span class="right">{{computeEnd}}</span>
        </p>
        <div class="hint">
          <span>提示：结束时间是以被复制班级的一次课时长为基准换算的，如需修改，请确认后修改当前复制的班级信息。</span>
        </div>
        <button @click="confirm" class="confirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {toMinutes} from 'common/js/toMinutes.js';
  export default{
    props: {
      title: {
        type: String
      },
      subtitle: {
        type: String
      },
      classinfo: {
        type: Object
      }
    },
    data(){
      return {
        bShow: false,
        startDateValue: '',
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < (Date.now() - 3600 * 24 * 1000);
          }
        },
        timeValue: new Date(2016, 9, 10, 8, 30),
      }
    },
    methods: {
      show() {
        this.startDateValue = '';
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'hidden';
        this.bShow = true;
      },
      hide(){
        this.bShow = false;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'auto';
      },
      confirm(){
        if (this.computeEnd > '24:00') {
          alert('结束时间不能大于24:00');
          return;
        }
        if (this.startDateValue != '') {
          let startdate = this.startDateValue.getFullYear() + '-' + (this.startDateValue.getMonth() + 1) + '-' + this.startDateValue.getDate();
          let starttime = this.timeValue.getHours() + ':' + this.timeValue.getMinutes();
          let copyinfo = {};
          copyinfo.startdate = startdate;
          copyinfo.starttime = starttime;
          copyinfo.classid = this.classinfo.id;
          this.$emit('confirm', copyinfo);
          this.hide();
        }else{
          this.$message({
            message: '请输入时间',
            type: 'danger'
          });
        }

      }
    },
    computed: {
      computeEnd() {
        let start = toMinutes(this.classinfo.starttime.substring(0, 5)); //开始时间转换成分钟,因为服务端的开始时间是"08:30:00"形式
        let end = toMinutes(this.classinfo.endtime.substring(0, 5));     //截止时间转换成分钟
        let startTime = this.timeValue.getHours() + ':' + this.timeValue.getMinutes();
        startTime = toMinutes(startTime);    //当前选取的开始时间转换成分钟
        let totalMinutes = startTime + end - start;
        let hour = parseInt(totalMinutes / 60);
        if (hour < 10) {
          hour = '0' + hour;
        } else {
          hour = '' + hour;
        }
        let minute = totalMinutes % 60;
        if (minute < 10) {
          minute = '0' + minute;
        } else {
          minute = '' + minute;
        }
        return hour + ':' + minute;
      }
    },
    watch: {
      classinfo(){
        this.timeValue = new Date('2016-9-10' + ' ' + this.classinfo.starttime);
        this.$forceUpdate();
      }
    },

  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .copy-pop
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    overflow: auto
    .dialog-wrapper
      margin: auto
      border-radius: 4px
      overflow: hidden
      background: #ffffff
      .head
        display: flex
        align-items: center
        justify-content: space-between
        height: 60px
        min-width: 510px
        background: #f2f2f2
        .title
          font-size: 20px
          color: #666666
          margin-left: 20px
          .sub-title
            font-size: 16px
        .close
          padding: 20px 10px
          cursor: pointer
      .content
        padding: 60px 55px 20px
        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            line-height: 35px
            margin-right: 10px
            width: 70px
            font-size: 14px
            color: #999999
          .right
            display: inline-block
            line-height: 35px
            font-size: 14px
            color: #666

        .hint
          display: flex
          align-items: center
          justify-content: center
          margin: 12px 0 40px 80px
          height: 45px
          width: 320px
          font-size: 12px
          color: #999999
          background: #fff9e7
          border: 1px solid #ffb76e
          box-sizing: border-box
          span
            padding: 6px
        .confirm
          display: block
          margin: 0 auto
          height: 48px
          line-height: 48px
          width: 150px
          text-align: center
          color: #ffffff
          font-size: 20px
          background: #3399ff
          border-radius: 4px

</style>



// WEBPACK FOOTER //
// src/components/copypop/CopyPop.vue